module.exports = __webpack_public_path__ + "static/media/levels_2_2.1b081e9f.svg";